import React, { useEffect, useState } from 'react'
import { fetchPage } from 'supporticon/api/pages'
import { deserializePage } from '../../../../lib/deserializePage'

import EditPageForm from './EditPageForm'
import Loading from '../../../ui/Loading'
import Section from 'constructicon/section'

const ManagePage = ({
  fitnessOptions,
  pageId,
  ...props
}) => {
  const [status, setStatus] = useState('fetching')
  const [page, setPage] = useState(null)

  useEffect(() => {
    fetchPage(pageId, true, { includeTags: true })
      .then(page => deserializePage(page, fitnessOptions.goalUom))
      .then(page => setPage(page))
      .then(() => setStatus('fetched'))
  }, [])

  switch (status) {
    case 'fetched':
      return (
        <EditPageForm
          {...props}
          fitnessOptions={fitnessOptions}
          fundraisingPage={page}
          pageId={pageId}
        />
      )
    default:
      return (
        <Section spacing={{ x: 1, y: 5 }}>
          <Loading />
        </Section>
      )
  }
}

export default ManagePage
